/**
 * Phone country codes for the PhoneInput component.
 * Sorted by priority for Saudi market — SA first, then regional, then international.
 *
 * To add a country: append one object with { code, dial, nameAr, nameEn, placeholder, digits }.
 * - code: ISO 3166-1 alpha-2
 * - dial: international dialing prefix with +
 * - nameAr: Arabic display name (used in current Arabic-only UI)
 * - nameEn: English display name (ready for Phase 2 i18n)
 * - placeholder: example local number format (digits only, no country code)
 * - digits: array of valid local number lengths (used for soft validation)
 */
export const PHONE_COUNTRIES = [
  { code: 'SA', dial: '+966', nameAr: 'السعودية', nameEn: 'Saudi Arabia', placeholder: '5XXXXXXXX', digits: [9] },
  { code: 'AE', dial: '+971', nameAr: 'الإمارات', nameEn: 'UAE', placeholder: '5XXXXXXXX', digits: [9] },
  { code: 'EG', dial: '+20', nameAr: 'مصر', nameEn: 'Egypt', placeholder: '1XXXXXXXXX', digits: [10] },
  { code: 'JO', dial: '+962', nameAr: 'الأردن', nameEn: 'Jordan', placeholder: '7XXXXXXXX', digits: [9] },
  { code: 'KW', dial: '+965', nameAr: 'الكويت', nameEn: 'Kuwait', placeholder: 'XXXXXXXX', digits: [8] },
  { code: 'BH', dial: '+973', nameAr: 'البحرين', nameEn: 'Bahrain', placeholder: 'XXXXXXXX', digits: [8] },
  { code: 'GB', dial: '+44', nameAr: 'المملكة المتحدة', nameEn: 'United Kingdom', placeholder: '7XXXXXXXXX', digits: [10, 11] },
  { code: 'US', dial: '+1', nameAr: 'الولايات المتحدة', nameEn: 'United States', placeholder: 'XXXXXXXXXX', digits: [10] },
  { code: 'PH', dial: '+63', nameAr: 'الفلبين', nameEn: 'Philippines', placeholder: '9XXXXXXXXX', digits: [10] },
];
